import type { CollectionReference, Firestore } from 'firebase/firestore'
import {
  collection,
  doc,
  query,
  where,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import { type FirestoreOrganizationSectionPassCoupon, schema } from './schema'
import { getDocsWithError } from '../../firestore-mobx/fetch'
import { convertDocumentSnapshotToModel } from '../../firestore-mobx/stream'
import { OrganizationSectionPassCoupon } from '../../models/OrganizationSectionPassCoupon'
import { type FirebaseRepository } from '../../models/FirebaseRepository'

const converter: FirestoreDataConverter<FirestoreOrganizationSectionPassCoupon> =
  {
    toFirestore: (data) => {
      return data
    },
    fromFirestore: (snapshot: QueryDocumentSnapshot) => {
      const data = snapshot.data({ serverTimestamps: 'estimate' })
      return schema.parse(data)
    },
  }

export const getOrganizationSectionPassCouponColRef = (
  firestore: Firestore,
  organizationId: string,
  folderId: string
): CollectionReference<FirestoreOrganizationSectionPassCoupon> => {
  return collection(
    firestore,
    'organization',
    organizationId,
    'section_pass_coupon_folder',
    folderId,
    'section_pass_coupon'
  ).withConverter(converter)
}

export const getOrganizationSectionPassCouponDocRef = (
  firestore: Firestore,
  organizationId: string,
  folderId: string,
  couponId: string
) => {
  return doc(
    getOrganizationSectionPassCouponColRef(firestore, organizationId, folderId),
    couponId
  )
}

export const fetchOrganizationSectionPassCoupons = async ({
  repository,
  organizationId,
  folderId,
  consumed,
}: {
  repository: FirebaseRepository
  organizationId: string
  folderId: string
  consumed: boolean
}) => {
  const couponsColRef = getOrganizationSectionPassCouponColRef(
    repository.firestore,
    organizationId,
    folderId
  ).withConverter(converter)

  const q = query(couponsColRef, where('consumed', '==', consumed))

  const snapshot = await getDocsWithError(
    q,
    'FetchOrganizationSectionPassCouponsError'
  )

  return snapshot.docs.map((doc) =>
    convertDocumentSnapshotToModel(
      repository,
      doc,
      OrganizationSectionPassCoupon
    )
  )
}
